import Typography from '../components/Layout/Wrappers/Typography';

const AppUI = {
  askTechnicalExpert: (
    <i>Tricky, ask technical expert to configure</i>
  ),
  disabled: 'Disabled',
  placeholder: {
    text: 'Type to edit',
    autocomplete: 'Type to search',
    multiline: 'Type to edit',
    tree: 'Type or click to select a location',
    multiple: 'Can select multiple options',
    number: 'Type a number',
    filterBar: 'Enter a Keyword'
  },
  publicInfo: {
    tooltip: 'Visible by recruiter'
  },
  success: {
    email: 'Email sent'
  },
  undoneAction: {
    message: 'This action cannot be undone.'
  },
  AdminOnly: {
    tooltip: 'Admin Only'
  },
  loggingOut: {
    message: 'Logging out...'
  },
  errorMessage: {
    viewResume: 'Resume is not available',
    viewScrubbedResume: 'Scrubbed resume is not available',
    unexpected: 'Sorry, something went wrong!',
    mlService: (
      <Typography className="text-capitalize">
        Sorry, something went wrong<br />with the matching score service
      </Typography>
    )
  }
};
export default AppUI;
